<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu thiết bị đã bán nhưng chưa kích hoạt</h1>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.requestCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã yêu cầu"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian tạo"
              class="w-100"
              :ranges="false"
              @update="transformDate('created')"
              v-model="dateRangeCreated"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian xác nhận"
              class="w-100"
              :ranges="false"
              @update="transformDate('confirmed')"
              v-model="dateRangeConfirmed"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian xác nhận
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian duyệt"
              class="w-100"
              :ranges="false"
              @update="transformDate('approved')"
              v-model="dateRangeApproved"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian duyệt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.createdBy"
              placeholder="Người tạo"
              :settings="settingSearch"
              :options="optionStaff"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.confirmedBy"
              placeholder="Người xác nhận"
              :settings="settingSearch"
              :options="optionStaff"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approvedBy"
              placeholder="Người duyệt"
              :settings="settingSearch"
              :options="optionStaff"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.regionId" :options="optionRegion" placeholder="Vùng"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryExportId"
              :options="optionInventory"
              placeholder="Kho đi"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryImportId"
              :options="optionInventory"
              placeholder="Kho đến"
            ></Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeExportInvoice"
              :options="optionTypeExport"
              placeholder="Đối tượng xuất HĐ"
            >
            </Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng số: <b class="text-primary">{{ pagination.total }}</b>
            <span v-for="(count, index) in countStatus" :key="index" class="mx-1">
              <span v-if="index > 0" class="mr-1">|</span> {{ getStatusText(count.status) }}:
              <b class="text-primary">{{ count.count }}</b></span
            >

            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="requestTickets"
              :fields="filterTable"
              :bordered="true"
              class="mt-2"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>

              <!-- Thông tin Merchant/Sale -->
              <template #cell(merchantInfo)="data">
                <div v-if="data.item.typeExportInvoice === 'EXPORT_FOR_SALE'">
                  <div class="mb-1">
                    <span class="text-muted">Tên:</span> {{ data.item.saleName }} -
                    {{ data.item.saleId }}
                  </div>
                  <div v-if="data.item.saleEmail" class="mb-1">
                    <span class="text-muted">Email:</span> {{ data.item.saleEmail }}
                  </div>
                  <div v-if="data.item.saleMobile" class="mb-1">
                    <span class="text-muted">SĐT:</span> {{ data.item.saleMobile }}
                  </div>
                  <div v-if="data.item.saleCitizenId" class="mb-1">
                    <span class="text-muted">CCCD:</span> {{ data.item.saleCitizenId }}
                  </div>
                  <div v-if="data.item.saleAddress" class="mb-1">
                    <span class="text-muted">Địa chỉ:</span> {{ data.item.saleAddress }}
                  </div>
                </div>
                <div v-else-if="data.item.typeExportInvoice === 'EXPORT_FOR_MERCHANT'">
                  <div class="mb-1">
                    <span class="text-muted">Tên:</span> {{ data.item.merchantName
                    }}{{ data.item.merchantCode ? ' - ' + data.item.merchantCode : '' }}
                  </div>
                  <div v-if="data.item.merchantEmail" class="mb-1">
                    <span class="text-muted">Email:</span> {{ data.item.merchantEmail }}
                  </div>
                  <div v-if="data.item.merchantMobile" class="mb-1">
                    <span class="text-muted">SĐT:</span> {{ data.item.merchantMobile }}
                  </div>
                  <div v-if="data.item.merchantCitizenId" class="mb-1">
                    <span class="text-muted">CCCD:</span> {{ data.item.merchantCitizenId }}
                  </div>
                  <div v-if="data.item.merchantAddress" class="mb-1">
                    <span class="text-muted">Địa chỉ:</span> {{ data.item.merchantAddress }}
                  </div>
                </div>
              </template>

              <!-- Số thiết bị -->
              <template #cell(totalDevice)="data">
                <span class="text-muted"> Tổng: </span> <b>{{ data.item.totalDevice }}</b>
              </template>

              <!-- Tên kho -->
              <template #cell(warehouse)="data">
                <div><span class="text-muted">Đi:</span> {{ data.item.inventoryExportName }}</div>
                <div><span class="text-muted">Đến:</span> {{ data.item.inventoryImportName }}</div>
              </template>

              <!-- Người -->
              <template #cell(people)="data">
                <div v-if="data.item.createdUser" class="mb-2">
                  <span class="text-muted">Tạo:</span> {{ getPersonInfo(data.item.createdUser) }}
                </div>
                <div v-if="data.item.confirmedUser" class="mb-2">
                  <span class="text-muted">Xác nhận:</span>
                  {{ getPersonInfo(data.item.confirmedUser) }}
                </div>
                <div v-if="data.item.approvedUser">
                  <span class="text-muted">Duyệt/Từ chối:</span>
                  {{ getPersonInfo(data.item.approvedUser) }}
                </div>
              </template>

              <!-- Thời gian -->
              <template #cell(time)="data">
                <div v-if="data.item.createdTime" class="mb-2">
                  <span class="text-muted">Tạo:</span>
                  {{ data.item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
                <div v-if="data.item.confirmedTime" class="mb-2">
                  <span class="text-muted">Xác nhận:</span>
                  {{ data.item.confirmedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
                <div v-if="data.item.approvedTime">
                  <span class="text-muted">Duyệt/Từ chối:</span>
                  {{ data.item.approvedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
              </template>

              <!-- Trạng thái -->
              <template #cell(status)="data">
                <span class="badge" :class="getBadgeClass(data.item.status)">
                  {{ data.item?.statusText }}
                </span>
                <div v-if="data.item?.reasonReject" class="mt-2 font-size-12">
                  <span class="text-muted">Lý do:</span> {{ data.item?.reasonReject }}
                </div>
              </template>

              <!-- Thao tác -->
              <template #cell(action)="data">
                <b-dropdown size="sm" variant="outline-light" class="m-0 p-0" no-caret>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEW' &&
                      dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_SA_CONFIRM')
                    "
                    @click="handleConfirmAction(data.item, 'SA')"
                  >
                    <span><i class="bx bx-check"></i> Xác nhận</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEW' &&
                      dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_SA_CONFIRM')
                    "
                    @click="handleRejectAction(data.item, 'SA')"
                  >
                    <span><i class="bx bx-x"></i> Từ chối</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      data.item.status === 'SA_CONFIRMED' &&
                      dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_APPROVE_REJECT')
                    "
                    @click="handleConfirmAction(data.item, 'GDV')"
                  >
                    <span><i class="bx bx-check"></i> Duyệt</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'SA_CONFIRMED' &&
                      dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_APPROVE_REJECT')
                    "
                    @click="handleRejectAction(data.item, 'GDV')"
                  >
                    <span><i class="bx bx-x"></i> Từ chối</span>
                  </b-dropdown-item>

                  <b-dropdown-item @click="onRowSelected(data.item)">
                    <span><i class="bx bx-show"></i> Chi tiết</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="fl-right mr-4"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import mxAction from './mx-action'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã yêu cầu' },
    { key: 'merchantInfo', label: 'Thông tin merchant/Sale' },
    { key: 'totalDevice', label: 'Số thiết bị' },
    { key: 'warehouse', label: 'Tên kho' },
    { key: 'regionName', label: 'Vùng' },
    { key: 'people', label: 'Người' },
    { key: 'time', label: 'Thời gian' },
    { key: 'status', label: 'Trạng thái', class: 'text-center' },
    { key: 'action', label: 'Thao tác', class: 'text-center' },
  ]

  export default {
    mixins: [prepareQueryParamsMixin, mxAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    data() {
      return {
        Config,
        loading: false,
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        optionStatus: Config.statusRequestTicket || [],
        optionTypeExport: [
          { id: '0', text: 'Tất cả' },
          { id: 'EXPORT_FOR_SALE', text: 'Xuất hóa đơn cho Sale' },
          { id: 'EXPORT_FOR_MERCHANT', text: 'Xuất hóa đơn cho Merchant' },
        ],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStaff: [],
        optionRegion: [],
        optionInventory: [],
        requestTickets: [],
        countStatus: [],
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        localeData: Config.localeData,
        dateRangeCreated: { startDate: null, endDate: null },
        dateRangeConfirmed: { startDate: null, endDate: null },
        dateRangeApproved: { startDate: null, endDate: null },
        tLoadAccount: null,
        settingSearch: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                const defaultResults = this.optionStaff.slice(0, 20)
                defaultResults.unshift({ id: '0', text: 'Tất cả' })
                return success({ results: defaultResults })
              }
              if (this.tLoadAccount) clearTimeout(this.tLoadAccount)
              this.tLoadAccount = setTimeout(() => {
                try {
                  let filtered = this.optionStaff.filter(staff =>
                    staff.text.toLowerCase().includes(txtSearch.toLowerCase())
                  )
                  filtered = filtered.slice(0, 20)
                  filtered.unshift({ id: '0', text: 'Tất cả' })
                  success({ results: filtered })
                } catch (error) {
                  failure(error)
                }
              }, 500)
            },
          },
        },
      }
    },
    created() {
      this.getListStaff()
      this.getListRegion()
      this.getListInventory()
      this.fetchData()
    },
    methods: {
      transformDate(type) {
        if (type === 'created') {
          if (this.dateRangeCreated.startDate && this.dateRangeCreated.endDate) {
            this.search.dateCreatedFrom = moment(this.dateRangeCreated.startDate)
              .startOf('day')
              .add(7, 'hours')
              .valueOf()
            this.search.dateCreatedTo = moment(this.dateRangeCreated.endDate)
              .endOf('day')
              .add(7, 'hours')
              .valueOf()
          } else {
            delete this.search.dateCreatedFrom
            delete this.search.dateCreatedTo
          }
        }
        if (type === 'confirmed') {
          if (this.dateRangeConfirmed.startDate && this.dateRangeConfirmed.endDate) {
            this.search.dateConfirmedFrom = moment(this.dateRangeConfirmed.startDate)
              .startOf('day')
              .add(7, 'hours')
              .valueOf()
            this.search.dateConfirmedTo = moment(this.dateRangeConfirmed.endDate)
              .endOf('day')
              .add(7, 'hours')
              .valueOf()
          } else {
            delete this.search.dateConfirmedFrom
            delete this.search.dateConfirmedTo
          }
        }
        if (type === 'approved') {
          if (this.dateRangeApproved.startDate && this.dateRangeApproved.endDate) {
            this.search.dateApprovedFrom = moment(this.dateRangeApproved.startDate)
              .startOf('day')
              .add(7, 'hours')
              .valueOf()
            this.search.dateApprovedTo = moment(this.dateRangeApproved.endDate)
              .endOf('day')
              .add(7, 'hours')
              .valueOf()
          } else {
            delete this.search.dateApprovedFrom
            delete this.search.dateApprovedTo
          }
        }
      },
      async getListStaff() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.success) {
            this.optionStaff = data.data.map(e => ({
              id: e.userId,
              text: `${e.userName} - ${e.name}`,
            }))
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => ({
              id: e.id,
              text: e.name,
            }))
            this.optionRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            this.optionInventory = data.data.map(e => ({
              id: e.id,
              text: e.name,
            }))
            this.optionInventory.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async submitForm(event) {
        if (event) event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRangeCreated = { startDate: null, endDate: null }
        this.dateRangeConfirmed = { startDate: null, endDate: null }
        this.dateRangeApproved = { startDate: null, endDate: null }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          // Clean params
          const params = cloneDeep(this.search)
          if (params.regionId === '0') delete params.regionId
          if (params.inventoryExportId === '0') delete params.inventoryExportId
          if (params.inventoryImportId === '0') delete params.inventoryImportId
          if (params.status === '0') delete params.status
          if (params.typeExportInvoice === '0') delete params.typeExportInvoice
          if (params.createdBy === '0') delete params.createdBy
          if (params.confirmedBy === '0') delete params.confirmedBy
          if (params.approvedBy === '0') delete params.approvedBy

          const response = await DeviceService.listRequestTicket(params)
          if (response.success) {
            this.requestTickets = response.data.requestTickets || []
            this.pagination = response.totalPage || { total: 0 }
            this.countStatus = response.data.countStatus || []
          }
        } catch (error) {
          console.log(error)
          this.requestTickets = []
        } finally {
          this.loading = false
        }
      },
      onRowSelected(item) {
        // Assuming URL pattern based on route definitions
        window.open(`/device-not-yet-activated/${item.id}`, '_blank')
      },
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },
      getPersonInfo(user) {
        if (!user) return ''
        return `${user.name} - ${user.companyCode} - ${user.typeSaleStr}`
      },
      getStatusText(status) {
        const found = this.optionStatus.find(s => s.id === status)
        return found ? found.text : status
      },
      getBadgeClass(status) {
        const found = this.optionStatus.find(s => s.id === status)
        return found ? found.bgColor : 'badge-secondary'
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
    padding-left: 0;
    padding-right: 0;
  }

  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
</style>
